import { VoteFunctions } from 'types/governance/voting';

export enum CrowdloanRewardsFunctions {
  CLAIM = 'claim',
}

export enum StakingFunctions {
  DELEGATE_WITH_AUTO_COMPOUND = 'delegateWithAutoCompound',
  AUTO_COMPOUND = 'setAutoCompound',
  BOND = 'delegatorBondMore',
  CANCEL = 'cancelDelegationRequest',
  DECREASE = 'scheduleDelegatorBondLess',
  EXECUTE = 'executeDelegationRequest',
  REVOKE = 'scheduleRevokeDelegation',
}

export enum ConvictionVotingFunctions {
  REMOVE_VOTE = 'removeVote',
  VOTE_YES = 'voteYes',
  VOTE_NO = 'voteNo',
  VOTE_SPLIT = 'voteSplit',
  VOTE_ABSTAIN = 'voteSplitAbstain',
}

export enum BatchFunctions {
  BATCH_ALL = 'batchAll',
}

export enum ReferendaFunctions {
  REFERENDUM_COUNT = 'referendumCount',
  SUBMISSION_DEPOSIT = 'submissionDeposit',
  DECIDING_COUNT = 'decidingCount',
  TRACK_IDS = 'trackIds',
  TRACK_INFO = 'trackInfo',
  REFERENDUM_STATUS = 'referendumStatus',
  ONGOING_REFERENDUM_INFO = 'ongoingReferendumInfo',
  CLOSED_REFERENDUM_INFO = 'closedReferendumInfo',
  KILLED_REFERENDUM_BLOCK = 'killedReferendumBlock',
  SUBMIT_AT = 'submitAt',
  SUBMIT_AFTER = 'submitAfter',
  PLACE_DECISION_DEPOSIT = 'placeDecisionDeposit',
  REFUND_DECISION_DEPOSIT = 'refundDecisionDeposit',
  REFUND_SUBMISSION_DEPOSIT = 'refundSubmissionDeposit',
}

export enum PreImageFunctions {
  NOTE_PREIMAGE = 'notePreimage',
  UNNOTE_PREIMAGE = 'unnotePreimage',
}

export enum ProxyFunctions {
  ADD_PROXY = 'addProxy',
  IS_PROXY = 'isProxy',
  PROXY = 'proxy',
  PROXY_FORCE_TYPE = 'proxyForceType',
  REMOVE_PROXIES = 'removeProxies',
  REMOVE_PROXY = 'removeProxy',
}

export type ContractFunction =
  | CrowdloanRewardsFunctions
  | StakingFunctions
  | ConvictionVotingFunctions
  | BatchFunctions
  | ReferendaFunctions
  | PreImageFunctions
  | VoteFunctions
  | ProxyFunctions;
